import { Component, ViewChild } from '@angular/core';
import { SlickCarouselComponent } from 'ngx-slick-carousel';

@Component( {
  selector: 'app-loader-questions',
  templateUrl: './loader-questions.component.html',
  styleUrls: ['./loader-questions.component.scss']
} )
export class LoaderQuestionsComponent {
  @ViewChild( 'slickModal', { static: true } ) slickModal: SlickCarouselComponent;
  slideConfig = {
    centerMode: true,
    slidesToShow: 1,
    dots: false,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 10000,
    variableWidth: true,
    arrows: true,
  };
  data = [
    {
      id: 1,
      question: '¿Por qué no ofrecen más dinero?',
      answer: 'El importe aprobado es en base a su historial crediticio que tiene con nosotros.' +
        ' Para una nueva evaluación tener en cuenta que se basa en la recaudación por GNV que haya ' +
        'tenido con nosotros, así como en otros parámetros que nuestro departamento de evaluaciones ha' +
        ' configurado en el sistema. '
    },
    {
      id: 2,
      question: '¿Cuánto tiempo tardan en desembolsar el dinero?',
      answer: 'Una vez firmados los documentos necesarios, el desembolso puede tardar hasta tres días hábiles. '
    },
    {
      id: 3,
      question: '¿Cómo se paga el crédito?',
      answer: 'El préstamo se paga automáticamente a través de la recaudación por tus recargas de GNV.' +
        ' con un factor de recaudo del 100%. Si enfrentas dificultades para cubrir la cuota mensual, deberás' +
        ' abonar en efectivo el saldo pendiente para evitar atrasarte y afectar tu calificación crediticia.'
    },
    {
      id: 4,
      question: '¿Me pueden "yapear" o darme el crédito en efectivo?',
      answer: '    El desembolso del préstamo se realizará en la cuenta bancaria a nombre del' +
        ' titular del crédito aprobado. Por ahora, este es el único método disponible para asegurar' +
        ' la confiabilidad del proceso.'
    },
    {
      id: 5,
      question: '¿Podrán darme otros préstamos cuando termine de pagar el actual?',
      answer: 'Solo toma en cuenta que durante la nueva evaluación se considerarán factores como:<br>' +
        'La propiedad del vehículo.<br>' +
        'La ausencia de inconvenientes con SAT, SUNAT, entre otras.<br>' +
        'La vigencia de tu sistema de GNV.<br>' +
        'Que el factor de recaudo no esté vinculado a otra institución.'
    },
    {
      id: 6,
      question: '¿Cuáles son las entidades que regulan a Credimóvil?',
      answer: 'Nuestros entes reguladores son SUNAT e INDECOPI.'
    },
  ];

  hideModal() {
    const modalElement = document.querySelector( '.modal' ) as HTMLElement;
    if ( modalElement ) {
      modalElement.style.display = 'none';
    }
  }

  onSlideChange( event: any ) {
    console.log( 'Slide cambiado:', event );
  }
}
